<template>
  <div class="code-guardian-container" style="width:100%;height:100%;padding: 0">
    <div ref="container" style="width:100%;height:100%;padding: 0" id="codeGuardian" class="code-guardian"/>
    <el-dialog
      v-if="problemInfoDialogVisible"
      :visible.sync="problemInfoDialogVisible"
      :fullscreen="true"
      custom-class="unlock-problem-info"
    >
      <problem-info-dialog :unlock-problem-info="problemId" @close="closeProblemInfoDialog"></problem-info-dialog>
    </el-dialog>
  </div>

</template>

<script>
const eventBus = new BroadcastChannel('eventBus')
import problemInfoDialog from "./problemInfoDialog";
export default {
  name: "code-guardian",
  components:{
    problemInfoDialog
  },
  watch: {
  },
  data() {
    return {
      problemInfoDialogVisible: false,
      problemId: null
    }
  },
  mounted() {
    eventBus.addEventListener('message', event => {
      let data = event.data;
      if(data.event === 'openUnlockProblemDialog'){
        this.openProblemInfoDialog(data.data.problemId)
      }
      // console.log("组件接收消息", event);
    })
    let ele = this.$refs.container
    const that = this
    const interval = setInterval(function() {
      if(that.$store.getters.gameLoadingFinish){
        eventBus.postMessage({
          event: 'showCodeBattleMainScene',
          data:{
            isShow: true,
            width: ele.offsetWidth,
            height: ele.offsetHeight
          }
        })
        clearInterval(interval)
      }
    },100)
  },
  beforeDestroy() {
    // 移除监听
    eventBus.removeEventListener('message', this.handleMessage);
  },
  destroyed() {
    eventBus.postMessage({
      event: 'show',
      data: {
        isShow: false
      }
    })
  },
  methods: {
    closeProblemInfoDialog() {
      eventBus.postMessage({
        event: 'gameNoticeReloadChipInfo'
      })
      eventBus.postMessage({
        event: 'gameNoticeCaptureAllKeyboardInput',
        data: {
          msg: 1
        }
      })
      this.problemInfoDialogVisible = false
    },
    openProblemInfoDialog(problemId) {
      eventBus.postMessage({
        event: 'gameNoticeCaptureAllKeyboardInput',
        data: {
          msg: 0
        }
      })
      this.problemId = problemId
      this.problemInfoDialogVisible = true
    }
  }
}
</script>
<style scoped>
.code-guardian-container >>> .el-dialog__header{
  display: none;
}
.code-guardian-container >>> .el-dialog__body{
  padding: 0;
  height: 100%;
}
</style>
